<template>
  <div class="flex gap-6">
    <WarningDisable permission="recon" />
    <div class="grow">
      <div class="mb-2 flex items-baseline justify-between">
        <div class="text-base-content/80 mb-2 text-xl font-bold">
          Lịch sử thu thập thông tin
        </div>
        <ConfirmCreate />
      </div>
      <Loading v-if="action_store.loading.get_action_history" />
      <template v-else-if="action_store.total_filter > 0">
        <div class="bg-base-100 mb-4 overflow-x-auto">
          <table class="table-pin-rows table-md table">
            <thead>
              <tr>
                <th></th>
                <th>Định danh</th>
                <th>Trạng thái</th>
                <th>Thời gian tạo</th>
                <th>Hành động</th>
              </tr>
            </thead>
            <tbody class="bg-base-200">
              <tr
                v-for="(action, idx) in action_store.actions"
                :key="action.id"
              >
                <th>
                  {{
                    idx +
                    1 +
                    (number_from_query("page", 1) - 1) *
                      number_from_query("size", 24)
                  }}
                </th>
                <td
                  class="cursor-pointer"
                  @click="
                    $router.push({
                      name: 'ClientReconScanDetail',
                      params: {
                        action_id: action.id,
                      },
                    })
                  "
                >
                  {{ action.id }}
                </td>
                <td
                  class="cursor-pointer"
                  @click="
                    $router.push({
                      name: 'ClientReconScanDetail',
                      params: {
                        action_id: action.id,
                      },
                    })
                  "
                >
                  <ActionStatusBadge :status="action.status" />
                </td>
                <td
                  class="cursor-pointer"
                  @click="
                    $router.push({
                      name: 'ClientReconScanDetail',
                      params: {
                        action_id: action.id,
                      },
                    })
                  "
                >
                  {{ dayjs(action.created).fromNow() }}
                </td>
                <td>
                  <button
                    v-if="
                      action.status !== 'complete' &&
                      action.status !== 'failed' &&
                      action.status !== 'stopped' &&
                      action.status !== 'stop'
                    "
                    class="btn btn-sm btn-outline btn-error"
                    :disabled="stopping_action_id === action.id"
                    @click="action.id && stop_action(action.id)"
                  >
                    <span v-if="stopping_action_id === action.id">
                      <Loading />
                    </span>
                    <span v-else>Dừng thu thập</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <Pagination :total_pages="action_store.total_pages" />
      </template>
      <NotFound v-else />
    </div>
  </div>
</template>

<script setup lang="ts">
import { number_from_query } from "@/api";
import { axios_instance } from "@/api/api";
import ActionStatusBadge from "@/components/ActionStatusBadge.vue";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import Pagination from "@/components/PaginationTemplate.vue";
import dayjs from "dayjs";
import { onMounted, ref } from "vue";
import { toast } from "vue3-toastify";
import { use_action } from "../ExplorerV2/useAction";
import WarningDisable from "../WarningDisable.vue";
import ConfirmCreate from "./ConfirmCreate.vue";

const action_store = use_action();
const stopping_action_id = ref<string | null>(null);

onMounted(() => {
  action_store.get_action_history({
    type: "recon",
    action: "scan",
  });
});

const stop_action = async (action_id: string) => {
  try {
    stopping_action_id.value = action_id;
    await axios_instance.post(`/api/v1/view/action/stop/${action_id}`);
    toast.success("Đã dừng thu thập thông tin.");
    action_store.get_action_history({
      type: "recon",
      action: "scan",
    });
  } catch (error) {
    console.error(error);
    toast.error("Đã xảy ra lỗi khi dừng thu thập thông tin.");
  } finally {
    stopping_action_id.value = null;
  }
};
</script>
